export default "__VITE_ASSET__aCKjC$Ov__"